import { render, staticRenderFns } from "./FileBoxesEditor.vue?vue&type=template&id=644f3878&scoped=true&"
import script from "./FileBoxesEditor.vue?vue&type=script&lang=ts&"
export * from "./FileBoxesEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FileBoxesEditor.vue?vue&type=style&index=0&id=644f3878&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f3878",
  null
  
)

export default component.exports